module.exports = __webpack_public_path__ + "img/welcome-icon.1f7d73a5.png";